function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import Cookies from "js-cookie";
import { ACCESS_TOKEN_COOKIE_NAME, LOCAL_STORAGE_KEY_NAME } from "./constants";
import { decodeObject, encodeObject } from "./encoding";
import { captureException } from "@lululemon/mwa-utils";
import hashEmail from "./utils/hash-email";
var isServer = function() {
    return typeof window === "undefined";
};
var isLoggedIn = function() {
    return Boolean(Cookies.get(ACCESS_TOKEN_COOKIE_NAME));
};
var profileIsUnavailable = function() {
    return isServer() || !isLoggedIn();
};
/**
 * Retrieves the value of a specific field from the user profile stored in localStorage, identified by the given key.
 * @param key
 * @returns {*}
 */ var getProfileField = function(key) {
    if (profileIsUnavailable()) return;
    try {
        var _profile;
        var base64String = localStorage.getItem(LOCAL_STORAGE_KEY_NAME);
        var profile = decodeObject(base64String);
        return (_profile = profile) == null ? void 0 : _profile[key];
    } catch (err) {
        captureException(err);
    }
};
/**
 * Fetches the entire user profile object from localStorage.
 * @returns {*}
 */ var getProfile = function() {
    if (profileIsUnavailable()) return;
    try {
        var base64String = localStorage.getItem(LOCAL_STORAGE_KEY_NAME);
        return decodeObject(base64String);
    } catch (err) {
        captureException(err);
    }
};
/**
 * Updates or adds a specific field in the user profile stored in localStorage, using the specified key-value pair.
 * @param key
 * @param value
 */ var setProfileField = function(key, value) {
    if (profileIsUnavailable()) return;
    try {
        var profile = getProfile();
        var base64String = encodeObject(_extends({}, profile, _define_property({}, key, value)));
        localStorage.setItem(LOCAL_STORAGE_KEY_NAME, base64String);
    } catch (err) {
        captureException(err);
    }
};
/**
 * Adds a hashedemail to the user profile stored in localStorage; used for Analytics soft profile after login.
 * @param email
 */ var setHashedEmail = function(email) {
    if (profileIsUnavailable()) return;
    if (email) {
        setProfileField("hashedEmail", hashEmail(email));
    }
};
/**
 * Replaces the current user profile in localStorage with the provided value.
 * @param value
 */ var setProfile = function(value) {
    if (profileIsUnavailable()) return;
    try {
        if (value) {
            var base64String = encodeObject(value);
            localStorage.setItem(LOCAL_STORAGE_KEY_NAME, base64String);
        } else {
            localStorage.removeItem(LOCAL_STORAGE_KEY_NAME);
        }
    } catch (err) {
        captureException(err);
    }
};
export { getProfileField, getProfile, setHashedEmail, setProfileField, setProfile };
